import script from "./UniqueComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./UniqueComponent.vue?vue&type=script&setup=true&lang=js"

import "./UniqueComponent.vue?vue&type=style&index=0&id=3c877d83&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c877d83"]])

export default __exports__